import { round2, formatPlayers } from '../../lib/format';

export const COMBINATION_GROUPS = [
  {
    title: 'Top Synergy Combinations (min 100 possessions played together)',
    item: 'synergy',
  },
  {
    title: 'Top Net Rating Combinations (min 100 possessions played together)',
    item: 'net_rating',
  },
  {
    title: 'Top Offensive Combinations (min 100 possessions played together)',
    item: 'off_rating',
  },
  {
    title: 'Top Defensive Combinations (min 100 possessions played together)',
    item: 'def_rating',
  },
];

export function toItems(category, combinations) {
  return (combinations || []).map(combination => ({
    id: `${category}-${getItemText(category, combination)}`,
    title: getItemText(category, combination),
    description: combination.players ? formatPlayers(combination.players) : '',
    ratings: getRatings(category, combination),
  }));
}

function getRatings(category, combination) {
  const ratings = combination.stats.values.ratings;

  const data = Object.keys(ratings).reduce((prevFactor, ratingKey) => {
    prevFactor[ratingKey] = { isBest: false, value: ratings[ratingKey] };

    return prevFactor;
  }, {});

  return [
    {
      title: formatPlayers(combination.players),
      data,
      name: '',
      category,
    },
  ];
}

function getItemText(category, combination) {
  switch (category) {
    case 'synergy':
      return `${round2(combination.stats.synergy.ratings.net)} per ${
        combination.stats.per
      } possessions`;
    case 'net_rating':
      return `${round2(combination.stats.values.ratings.net)} per ${
        combination.stats.plus_minus.per
      } possessions`;
    case 'off_rating':
      return `${round2(combination.stats.values.ratings.offense)} per ${
        combination.stats.per
      } possessions`;
    case 'def_rating':
      return `${round2(combination.stats.values.ratings.defense)} per ${
        combination.stats.per
      } possessions`;
    default:
      return '';
  }
}
